exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-datatable-thead .ui-state-default th.ui-state-default {\n  background: #2196F3;\n  color: white; }\n\n.ui-dropdown-item-empty, .ui-dropdown-label-empty {\n  text-indent: 0px !important; }\n\n.assignOverlay .ui-widget-content .ui-inputtext {\n  color: white; }\n\n.main-container {\n  height: 500px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/admin-module/import-players/import-players.component.scss
// module id = ../../../../../src/app/admin-module/import-players/import-players.component.scss
// module chunks = main